const ote = {
  "CO": 0,
  "VV": 0,
  "V": 0,
  "OI": 0,
  "economie": 0,
  "inputGlobas": 0,
  "WG": 0,
  "VG": 0,
  "overfinanced": [],
  "debitCredit": [],
  "WI": 0,
  "GZ": 0,
  "OW": 0,
  "VR": 0,
  "IE": 0,
  "FB": 0,
  "LV": 0,
  "WS": 0,
  "MC": 0,
  "OT": 0,
  "KN": 0,
  "OH": 0,
  "HB": 0,
  "EH": 0,
  "R1": 0,
  "R2": 0,
  "R3": 0,
  "R4": 0,
  "R5": 0,
  "R5A": 0,
  "R6": 0,
  "R7": 0,
  "R8": 0,
  "R9": 0,
  "R10": 0,
  "R10A": 0,
  "R11": 0,
  "R12": 0,
  "R13": 0,
  "R14": 0,
  "R15": 0,
  "R16": 0
};

function getGameStateSum(states) {
  return states.reduce((r,s) => {
      Object.keys(s).forEach(key => {
        r[key] = (r[key] || 0) + s[key];
      });
      r.OneTimeEffect = s.OneTimeEffect;
      return r;
    }, {
      OneTimeEffect: { ...ote },
      globas: 0,
      points: 0,
    }
  );
}

export {
  getGameStateSum,
};



// WEBPACK FOOTER //
// ./src/helpers/gameStateHelpers.js